import axiosInstance from "services/axiosMiddleware";

export async function deleteRelaxation({id}) {
    if(!id){
        throw new Error("Relaxation ID is required")
    }
    try {
        const response = await axiosInstance.delete(`/relaxation/${id}`)
        return response.data;
    } catch (error) {
        const msg = error ?.response?.data?.message || error.message || "delete failed";
        console.error('Delete failed',error);
        throw new Error(msg)
    }
    
}   